import styles from "./explanationPage.module.css";
import AppBar from "../../components/appBar/appBar";
import ImgBuilder from "../../assets/ImgBuilder";
import AbortGame from "../../components/abortGame/abortGame";

import { renderWithLineBreaksAndBold } from '../../functions/renderWithLineBreaksAndBold';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";


const ExplanationPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // to render rypes glasses
  const infoTypes = t("explanation.info_types", { returnObjects: true });

  const handleClick = () => {
    // Go to the new connected to this topic
    navigate("/news")
  };
  
  return (
    <div className={styles.wrapper}>
      <AppBar />
      <AbortGame />
      <div className={styles.container}>
        
        <p className={styles.pageName}>{renderWithLineBreaksAndBold(t("explanation.explanation_title"))}</p>

        <p className={styles.mainText}>
          {renderWithLineBreaksAndBold(t("explanation.explanation_subtitle"))}
        </p>

        <div className={styles.glassContainer}>
          {infoTypes.map((item, idx) => 
            <div key={idx} className={styles.glass}>
              <div  className={styles.containerInfoGlass}>
                <p className={styles.glassName}>{renderWithLineBreaksAndBold(item.type_name)}</p>
                <ul className={styles.glassDescription}>
                  {item.type_points.map((point, point_idx) => 
                    <li key={point_idx} className={styles.glassDescription_li}>{point}</li>
                  )}
                </ul>
              </div>
              {/* <div className={styles.headlineExample}>{renderWithLineBreaksAndBold(item.type_example)}</div> */}
            </div>
            )}

        </div>
      </div>

      <div className={styles.buttonsContainer}>
        <p className={styles.tip}>{renderWithLineBreaksAndBold(t("explanation.tip"))}</p>
        <button onClick={() => handleClick()}  className={styles.button}>{t("explanation.readiness")}</button>
      </div>
      <img alt="bg" className={styles.bgImg} src={ImgBuilder.topicsBg}/>

    </div>


  );
};

export default ExplanationPage;
